import React, { useState, useEffect } from "react";
import Swiper from "swiper";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Lazy,
  Autoplay,
  EffectFade,
} from "swiper";

// import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "./bannerSlider.css";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";
import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import BookIcon from "@material-ui/icons/Book";
import { Link } from "react-router-dom";
// install Swiper components
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade]);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    totalSector: {
      marginTop: "8%",
      display: "flex",
      fontFamliy: "Gothic A1",
    },
    leftDivSector: { paddingRight: "6rem" },
    imgSec: {
      // position: "relative",
      width: "100%",
    },

    aspectRatioBox: {
      //   height: 0,
      overflow: "hidden",
      //   paddingTop: "calc(591.44px / 1127.34px * 100%)",
      //   paddingTop: "100%",
      // paddingTop: "56.25%",
      paddingTop: "52.3%",

      position: "relative",
    },

    aspectRatioBoxInside: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
    fireboxCentering: {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    viewPortSizing: {
      fontSize: "5vw",
    },
  })
);

interface AspectDivProps {
  children: React.ReactNode;
}
function AspectDivHompage(props: AspectDivProps) {
  const classes = useStyles();

  return (
    <Grid
      item
      xs={12}
      className={classes.aspectRatioBox}
      style={{
        display: "white",
        backgroundImage: "linear-gradient(45deg,#ffb040,#ffd62e)",
        // backgroundImage:
        //   "linear-gradient(45deg,var(--gradient-yellow-start),var(--gradient-yellow-end))",
      }}
    >
      <Grid item xs={12} className={classes.aspectRatioBoxInside}>
        <Grid item xs={12} className={classes.fireboxCentering}>
          <Grid item xs={12} className={classes.viewPortSizing}>
            {props.children}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

function AspectDivBlog(props: AspectDivProps) {
  const classes = useStyles();

  return (
    <Grid
      item
      // xs={12}
      className={classes.aspectRatioBox}
      style={{
        backgroundImage: "linear-gradient(45deg,#f857a6,#ff5858)",

        // backgroundImage:
        //   "linear-gradient(45deg,var(--gradient-red-start),var(--gradient-red-end))",
      }}
    >
      <Grid item xs={12} className={classes.aspectRatioBoxInside}>
        <Grid item xs={12} className={classes.fireboxCentering}>
          <Grid item xs={12} className={classes.viewPortSizing}>
            {props.children}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

function BannerSlider() {
  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  useEffect(() => {
    const swiper = new Swiper(".swiper-container", {
      speed: 1000,
      // spaceBetween: 100,
      autoplay: {
        delay: 10000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            " banner" +
            '">' +
            (index + 1) +
            "</span>"
          );
        },
      },
    });
    setSwiperInstance(swiper);
  }, []);

  return (
    <Grid className="swiper-container" style={{ width: "100%" }}>
      <Grid className="swiper-wrapper">
        <div className="swiper-slide">
          <AspectDivHompage>
            <Grid
              xs={12}
              item
              container
              // direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid
                // xs={2}
                item
                style={{
                  fontSize: 16,
                  color: "white",
                  // color: "black",

                  paddingTop: 8,
                  paddingRight: 32,
                }}
              >
                <HomeIcon style={{ fontSize: 64 }} />
              </Grid>
              <Grid
                // xs={5}
                item
                component={"a"}
                href="https://nodan119.modoo.at"
                target="_blank"
                style={{
                  fontFamily: "Noto Sans KR",
                  fontSize: 20,
                  fontWeight: 700,
                  color: "white",
                  // color: "black",

                  textAlign: "right",
                }}
              >
                (사)노동인권연대
                <br />
                홈페이지 바로가기
                <br />
              </Grid>
              {/* </a> */}
            </Grid>
          </AspectDivHompage>
        </div>
        <Grid className="swiper-slide">
          <AspectDivBlog>
            <Grid
              xs={12}
              item
              container
              // direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid
                // xs={1}
                item
                style={{
                  fontSize: 16,
                  color: "white",
                  // color: "black",

                  paddingTop: 8,
                  paddingRight: 32,
                }}
              >
                <BookIcon style={{ fontSize: 64 }} />
              </Grid>
              <Grid
                // xs={5}
                item
                component={"a"}
                href="https://blog.naver.com/nodan21"
                target="_blank"
                style={{
                  fontFamily: "Noto Sans KR",
                  fontSize: 20,
                  fontWeight: 700,
                  color: "white",
                  // color: "black",

                  textAlign: "right",
                }}
              >
                (사)노동인권연대
                <br />
                블로그 바로가기
                <br />
              </Grid>
            </Grid>
          </AspectDivBlog>
        </Grid>
      </Grid>
      {/* <div className="swiper-pagination">
        <span className="swiper-pagination-bullet"></span>
      </div> */}
      <Grid
        className="swiper-button-prev banner-prev"
        style={{ left: "5%", color: "white" }}
      ></Grid>
      <Grid
        className="swiper-button-next banner-next"
        style={{ right: "5%", color: "white" }}
      ></Grid>
    </Grid>
  );
}

export default BannerSlider;
